define('shared/remote/account/current',[
    '$',
    'shared/remote/ajax'
], 
function(
    $,
    ajax
){
    return function(options) {
        return ajax({
            url: '/1/api/account/v1/accounts?' + ['schoolId','b2c.englishlive'].join('='),
            resolveXHR: true
        })
        .then(function(value){
            var xhr = value.xhr;
            var ret = value.data;
            var efAccess = xhr.getResponseHeader('X-EF-ACCESS');
            if (efAccess) {
                if (options && options.raw) {
                    ret.access = efAccess;
                }
                else {
                    var jwt = efAccess.split('.');
                    var jwtPayload = jwt[1];
                    if (jwtPayload) {
                        ret.access = JSON.parse(atob(jwtPayload));
                    }
                }
            }

            return ret;
        });
    };
});
